// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y2OSH","placeholdersHeader":"styles_placeholdersHeader__21GkO","editorStyle":"styles_editorStyle__tyP1l","placeholdersBox":"styles_placeholdersBox__miXjQ"};